import { MouseEvent, ReactElement } from 'react';

import { DocumentCategoryIcons } from 'constants/DocumentCategoryIcons';

import { ChipDeleteBtn, ChipLabel, ChipW, IconLabelW, LabelW, StyledTagLabel } from './styled';

interface TagLabelProps {
  icon?: string;
  identify: string;
  label?: string;
  type?: string;
  onDelete?: (value: string) => void;
  value?: string;
}

export const CustomSelectedValue = ({
  icon,
  identify,
  label,
  type,
  onDelete,
  value,
}: TagLabelProps): ReactElement => {
  const handleDelete = (e: MouseEvent) => {
    e.stopPropagation();
    if (onDelete && value !== undefined) {
      onDelete(value);
    }
  };

  switch (identify) {
    case 'tags': {
      const Icon = icon ? DocumentCategoryIcons[icon.toLowerCase()] : null;
      return (
        <StyledTagLabel>
          <span>{Icon}</span>
          {label}
        </StyledTagLabel>
      );
    }
    case 'icon': {
      return <IconLabelW>{label}</IconLabelW>;
    }
    default: {
      if (onDelete) {
        return (
          <ChipW>
            <ChipLabel>{label}</ChipLabel>
            <ChipDeleteBtn
              onClick={handleDelete}
              onMouseDown={(e) => e.stopPropagation()}
              type="button"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </ChipDeleteBtn>
          </ChipW>
        );
      }
      if (type) {
        return (
          <div>
            <ChipW>
              <ChipLabel>{label}</ChipLabel>
            </ChipW>
          </div>
        );
      }
      return <LabelW>{label}</LabelW>;
    }
  }
};
